import { render } from "./OrdersProgress.vue?vue&type=template&id=2fc742b1"
import script from "./OrdersProgress.vue?vue&type=script&lang=js"
export * from "./OrdersProgress.vue?vue&type=script&lang=js"

import "./OrdersProgress.vue?vue&type=style&index=0&id=2fc742b1&lang=css"

import exportComponent from "../../../../../../../../../../Users/karimdmai2026/Eurekali-Souverainete/eurekali-b2c/eurekaliAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__